import { Button, IconClose, Layout, Modal, Text, cnMixCard, cnMixSpace } from 'uikit';

import type React from 'react';
import { useState, useCallback, useEffect } from 'react';

import styles from './BimWorkOrderPriceMtrDistEditConfirmationDialog.module.css';

interface IBimWorkOrderPriceMtrDistEditConfirmationDialog {
    isOpened: boolean;
    onSubmit: () => void;
    onClose: (value: boolean) => void;
}

const bodyStyle = { padding: '0 24px' };

export const BimWorkOrderPriceMtrDistEditConfirmationDialog: React.FC<
    IBimWorkOrderPriceMtrDistEditConfirmationDialog
> = ({ isOpened, onSubmit, onClose }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleClose = useCallback(() => {
        onClose(false);
    }, [onClose]);

    const handleOk = useCallback(() => {
        setIsLoading(true);
        onSubmit();
    }, [onSubmit]);

    useEffect(
        () => () => {
            setIsLoading(false);
        },
        [],
    );

    return (
        <Modal isOpen={isOpened} hasOverlay style={{ minHeight: '204px', width: '520px' }}>
            <>
                <div className={styles.header}>
                    <Text transform="uppercase" view="secondary" lineHeight="l" size="s" weight="semibold">
                        Редактирование стоимости
                    </Text>
                    <Button
                        disabled={isLoading}
                        onClick={handleClose}
                        label="Закрыть"
                        iconSize="s"
                        iconLeft={IconClose}
                        view="clear"
                        onlyIcon
                    />
                </div>
                <Layout
                    className={cnMixCard({
                        verticalSpace: 'l',
                    })}
                    flex={1}
                >
                    <Text style={bodyStyle}>
                        При перераспределении МТР изменилась исходная итоговая стоимость сметы.
                    </Text>
                </Layout>
                <Layout className={styles.footer} style={{ justifyContent: 'right' }}>
                    <Button
                        loading={isLoading}
                        className={cnMixSpace({ mR: 'm' })}
                        label="Сохранить"
                        onClick={handleOk}
                    />
                    <Button disabled={isLoading} label="Отменить" onClick={handleClose} view="ghost" />
                </Layout>
            </>
        </Modal>
    );
};

BimWorkOrderPriceMtrDistEditConfirmationDialog.displayName = 'BimWorkOrderPriceMtrDistEditConfirmationDialog';
